import styled from 'styled-components'

export const FormContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  max-width: 1250px;
`

export const FormSubContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

export const HeaderContainer = styled.div`
  display: flex;
  width: 90%;
`

export const SubHeaderContainer = styled.div`
  display: flex;
  width: 40%;
  justify-content: space-between;
`

export const HeaderPauseAndIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  justify-content: space-between;
  height: 100%;
  gap: 0.5rem;
`

export const HeaderIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 100%;
`

export const HeaderIcon = styled.img`
  width: 24px;
  height: 24px;
`
